<template>
  <div class="view">
    <div class="congratulation">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 180 181">
        <defs>
          <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="a">
            <stop stop-color="#FB8697" offset="0%"/>
            <stop stop-color="#F54E5E" offset="100%"/>
          </linearGradient>
          <path d="M86.96 47c26.4 0 50.04 9.06 65.99 23.36l25.35-6.73a1.1 1.1 0 011.37.86c1.53 7.67-2.35 13.31-10.61 17.04a43.3 43.3 0 01-4.76 1.8c6.15 9.2 9.62 19.62 9.62 30.67 0 37-38.93 67-86.96 67C38.93 181 0 151 0 114s38.93-67 86.96-67zm0 11.06C44.4 58.06 10.9 83.86 10.9 114c0 30.13 33.5 55.94 76.05 55.94S163 144.14 163 114c0-10.12-3.77-19.75-10.4-28.08-2.6.4-5.36.72-8.3.98 7.7 5.65 12.33 14.07 12.33 23.17 0 11.01-6.79 21.04-17.58 26.36a38.97 38.97 0 01-33.94 0 34.76 34.76 0 01-6.09-3.82c-.89 1.1-1.85 2.24-2.82 3.37l-.53.61c-2.92 3.35-5.86 6.41-7.26 7.25-2.27-1.17-5.9-5.51-9.38-10.04l-.58-.76c-1.63-2.14-3.2-4.29-4.57-6.12.79-1.07 2.11-1.06 3.46-.96l.76.05c1.1.08 2.14.1 2.87-.48 2.95-3.35 6.16-8 6.56-15.35v-.11c0-11.02 6.79-21.04 17.58-26.36a37.7 37.7 0 019.61-3.2l25.03-6.65c-13.6-9.71-32.12-15.8-52.8-15.8zm22.36 34.44c-7.6 3.74-12.15 10.46-12.15 17.57 0 7.1 4.55 13.82 12.15 17.57a29.45 29.45 0 0025.51 0c7.6-3.75 12.15-10.47 12.15-17.57s-4.54-13.83-12.15-17.57a29.45 29.45 0 00-25.5 0zm-54.49 2.57c8.73 0 15.8 6.73 15.8 15.04 0 8.3-7.07 15.04-15.8 15.04-8.72 0-15.8-6.74-15.8-15.04 0-8.3 7.08-15.04 15.8-15.04zm67.59 0c8.72 0 15.8 6.73 15.8 15.04 0 8.3-7.08 15.04-15.8 15.04s-15.8-6.74-15.8-15.04c0-8.3 7.08-15.04 15.8-15.04zm-70.5 5.53c-3.63 0-6.58 3.32-6.58 7.42s2.95 7.43 6.59 7.43c3.64 0 6.59-3.33 6.59-7.43s-2.95-7.42-6.6-7.42zm67.6 0c-3.65 0-6.6 3.32-6.6 7.42s2.95 7.43 6.6 7.43c3.63 0 6.58-3.33 6.58-7.43s-2.95-7.42-6.59-7.42zm-68.35 5.16c-.72.4-1.03 1.38-1.03 2.27 0 .86.33 1.82 1 2.26-1.3-.3-2.26-1.29-2.26-2.26 0-.9.82-1.82 1.97-2.18l.19-.06.13-.03zm67.58 0c-.71.4-1.02 1.38-1.02 2.27 0 .86.33 1.82.99 2.26-1.3-.3-2.25-1.29-2.25-2.26 0-.9.82-1.82 1.97-2.18l.18-.06.13-.03zm-66.06 0c1.32.3 2.3 1.33 2.3 2.27 0 .93-.96 1.95-2.26 2.26.67-.45 1-1.43 1-2.26 0-.78-.26-1.67-.85-2.14l-.13-.1-.06-.03zm67.59 0c1.32.3 2.3 1.33 2.3 2.27 0 .93-.96 1.95-2.26 2.26.66-.45 1-1.43 1-2.26 0-.78-.26-1.67-.85-2.14l-.13-.1-.06-.03zM63.59 80.74a4.86 4.86 0 013.7 4.03l.18 1.13a4.86 4.86 0 01-4.77 5.62h-4.46c-4.41 0-7.58-.02-10.68-.1l-.85-.02-.85-.02-2.16-.07c-5.37-.19-6.46-7.79-1.36-9.51a39.33 39.33 0 0121.25-1.06z" id="b"/>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <use fill="url(#a)" xlink:href="#b"/>
          <use fill-opacity=".15" fill="url(#d)" xlink:href="#b"/>
          <path d="M131.97 36v17.77c0 .06.03.13.03.2C132 62.26 112.07 69 87.5 69 62.92 69 43 62.27 43 53.96V36l44.49 10.76L131.97 36zM87.5 0L162 23.02l-30.05 8.63L87.5 42.63 43.05 31.65l-3.62-1.04 7.83-2.05.74-1.46L37.5 29v2.11L35.63 56.5c-7.06 3.38-14.11 0-14.11 0-1.66-9.29 9.64-28.27 9.64-28.27l.73-1.73 5-.95-.82-.7-5.84.4-1.35 2.33L13 23.02 87.5 0z" fill="#3A3A3A" fill-rule="nonzero"/>
        </g>
      </svg>
      <p class="congratulation__title" v-if="userType === 0">Уважаемый родитель! Ваш ребенок закончил начальную школу.</p>
      <p class="congratulation__title" v-if="userType === 1">Уважаемый родитель! Ваш ребенок окончил детский сад.</p>
      <p class="congratulation__text">Команда СОВЫ поздравляет вас с выпуском и желает качественного образования вашим детям.</p>
      <p class="congratulation__text congratulation__footer">Ваш аккаунт будет удален.<br>
        Спасибо, что были с нами!</p>
      <material-button value="Выход" color="pink-gradient" size="md" class="congratulation__exit-button" @click.native="exit"></material-button>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/button/MaterialButton";
export default {
  name: "CongratulationView",
  components: {MaterialButton},
  computed:{
    userType(){
      return this.$store.getters.PROFILE?._schoolClass?.type
    }
  },
  methods:{
    async exit(){
      await this.$store.dispatch("RESET_STATE_TO_DEFAULT")
      await this.$store.dispatch("EXIT_FROM_ACCOUNT");

      // await this.$router.push({name:"NewAuth"})
      document.location.href = '/auth'
    }
  },
  async mounted() {
    await this.$store.dispatch("GET_PROFILE")
  }
}
</script>

<style scoped lang="scss">
  .view{
    width: 100%;
    height: 100%;
    background-color: #f8f8f8;
    display: flex;
    align-items: center;
    justify-content: center;


    .congratulation{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 320px;


      @include for-mobile-devices{
        margin-bottom: 20px;
      }

      svg{
        @include for-mobile-devices{
          width: 180px;
          height: 181px;
        }

        @include for-desktop-devices{
          //transform: scale(0.8);
          //margin-bottom: -20px;
          height: auto;
          width: 144px;
        }
      }

      &__title{
        margin-top: 17px;
        font-family: Roboto, 'sans-serif';
        font-weight: 500;
        font-size: 18px;
        line-height: 23px;
        letter-spacing: 0.39px;
        text-align: center;
      }

      &__text{
        margin-top: 4px;
        font-size: 16px;
        font-weight: 300;
        font-family: Roboto, 'sans-serif';
        line-height: 21px;
        letter-spacing: 0.35px;
        text-align: center;
      }

      &__footer{
        color: #9B9B9B;

        @include for-desktop-devices{
          margin-top: 40px;
        }

        @include for-mobile-devices{
          margin-top: 81px;
        }
      }

      &__exit-button{
        margin-top: 16px;
      }
    }
  }
</style>
